import React from 'react';
import PropTypes from 'prop-types';

const ShowerNot = ({ color = '#BCC6CA', lineColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.071 10V8c0-.53.166-1.04.46-1.414.295-.375.695-.586 1.112-.586h4.714c.417 0 .817.21 1.111.586.295.375.46.884.46 1.414v2M8.5 10h11"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 22V4a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v2m-4 8h.01M14 14h.01M18 14h.01M9 18h.01M14 18h.01M19 18h.01M8 22h.01M14 22h.01M20 22h.01"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={lineColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

ShowerNot.propTypes = {
  color: PropTypes.string,
  lineColor: PropTypes.string
};

export default ShowerNot;
